<template>
  <div id="app">
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <img id="logo" src="/assets/logo.png">
        </div>
        <div class="col-md-6">
          <h1>{{ TITLE }}</h1>
        </div>
      </div>
      <h4>Datos Mueble</h4>
      <div class="row">
        <div class="col-lg-2 col-md-3">
          <div class="form-group">
            <label for="sltMueble">Mueble</label>
            <select class="form-control" id="sltMueble" v-model="mueble">
              <option v-for="(mueble, indice) in MUEBLES" :key="indice">{{ mueble }}</option>
            </select>
          </div>
        </div>
        <div class="col-lg-2 col-md-3" v-if="mueble === 'Pieza Libre'">
          <div class="form-group">
            <label for="inpNombrePiezaLibre">Nombre</label>
            <input type="text" class="form-control" id="inpNombrePiezaLibre" v-model="nombrePiezaLibre" aria-describedby="pieza libre" placeholder="Pieza">
          </div>
        </div>
        <div class="col-lg-2 col-md-3" v-if="mueble === 'Pieza Libre'">
          <div class="form-group">
            <label for="inpNumPiezaLibre">Cantidad</label>
            <input type="number" class="form-control" id="inpNumPiezaLibre" v-model="numPiezaLibre" aria-describedby="pieza libre" placeholder="Número" min="0" step="1">
          </div>
        </div>
        <div class="col-lg-2 col-md-3">
          <div class="form-group">
            <label for="sltGrosorMueble">Grosor</label>
            <select class="form-control" id="sltGrosorMueble" v-model="grosorMueble">
              <option v-for="(grosor, indice) in GROSORES_MUEBLE" :key="indice" :value="grosor">{{ grosor * 10 }} mm</option>
            </select>
          </div>
        </div>
        <div class="col-lg-2 col-md-3" v-if="mueble === 'Casco Alto' || mueble === 'Casco Bajo' || mueble === 'Rincón' || mueble === 'Escurreplatos'">
          <div class="form-group">
            <label for="inpNumBaldas">Baldas</label>
            <input type="number" class="form-control" id="inpNumBaldas" v-model="numBaldas" aria-describedby="baldas" placeholder="Número" min="0" step="1">
          </div>
        </div>
        <div class="col-lg-2 col-md-4 col-sm-4 mt-4">
          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chkHidrofugo" v-model="isHidrofugo">
              <label class="form-check-label" for="chkHidrofugo">
                Hidrófugo
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-1 col-md-4 col-sm-4 mt-4" v-if="mueble === 'Casco Alto' || mueble === 'Casco Bajo' || mueble === 'Rincón'">
          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chkTrasera" v-model="isTrasera">
              <label class="form-check-label" for="chkTrasera">
                Trasera
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-1 col-md-4 col-sm-4 mt-4" v-if="mueble === 'Casco Alto' || mueble === 'Casco Bajo' || mueble === 'Rincón'">
          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chkCanal" v-model="isCanal">
              <label class="form-check-label" for="chkCanal">
                Canal
              </label>
            </div>
          </div>
        </div>
        <div class="col-lg-1 col-md-4 col-sm-4 mt-4" v-if="mueble === 'Casco Alto' || mueble === 'Casco Bajo' || mueble === 'Rincón'">
          <div class="form-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="chkGola" v-model="isGola">
              <label class="form-check-label" for="chkGola">
                Gola
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="mueble === 'Casco Alto' || mueble === 'Casco Bajo'">
        <div class="col-lg-2 col-md-2">
          <div class="form-group">
            <label for="inpNumDivisores">Divisores</label>
            <input type="number" class="form-control" id="inpNumDivisores" v-model="numDivisores" aria-describedby="divisores" placeholder="Número" min="0" step="1">
          </div>
        </div>
        <template v-if="this.numDivisores > 0">
          <div class="col-sm-2 col-md-2 mt-4">
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="posicionDivisor" id="posicionDivisorOp1" :value="DIVISOR.POSICION.op1">
              <label class="form-check-label" for="posicionDivisorOp1">{{ DIVISOR.POSICION.op1 }}</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="posicionDivisor" id="posicionDivisorOp2" :value="DIVISOR.POSICION.op2">
              <label class="form-check-label" for="posicionDivisorOp2">{{ DIVISOR.POSICION.op2 }}</label>
            </div>
          </div>
          <div class="col-sm-2 col-md-2 mt-4">
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="ajusteDivisor" id="ajusteDivisorOp1" :value="DIVISOR.AJUSTE.op1">
              <label class="form-check-label" for="ajusteDivisorOp1">{{ DIVISOR.AJUSTE.op1 }}</label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="ajusteDivisor" id="ajusteDivisorOp2" :value="DIVISOR.AJUSTE.op2">
              <label class="form-check-label" for="ajusteDivisorOp2">{{ DIVISOR.AJUSTE.op2 }}</label>
            </div>
          </div>
        </template>
      </div>

      <div class="row" v-if="mueble !== 'Rincón'">
        <div class="col-md-4">
          <div class="form-group">
            <label for="txtAlto">Alto(cm)</label>
            <input type="number" class="form-control" id="txtAlto" v-model="altoMueble" aria-describedby="alto" placeholder="Alto"
              min="0" step="0.1">
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="txtAncho">Ancho(cm)</label>
            <input type="number" class="form-control" id="txtAncho" v-model="anchoMueble" aria-describedby="ancho" placeholder="Ancho"
              min="0" step="0.1">
          </div>
        </div>
        <div class="col-md-4" v-if="mueble !== 'Pieza Libre'">
          <div class="form-group">
            <label for="txtFondo">Fondo(cm)</label>
            <input type="number" class="form-control" id="txtFondo" v-model="fondoMueble" aria-describedby="fondo" placeholder="Fondo"
              min="0" step="0.1">
          </div>
        </div>
      </div>

      <div class="row" v-if="mueble === 'Rincón'">
        <div class="col-md-2 offset-md-1">
          <div class="form-group">
            <label for="txtAltoRincon">Alto(cm)</label>
            <input type="number" class="form-control" id="txtAltoRincon" v-model="altoRincon" aria-describedby="fondo" placeholder="Alto"
              min="0" step="0.1">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="txtAnchoMayorRincon">Ancho mayor(cm)</label>
            <input type="number" class="form-control" id="txtAnchoMayorRincon" v-model="anchoMayorRincon" aria-describedby="ancho" placeholder="Ancho"
              min="0" step="0.1">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="txtFondoMayorRincon">Fondo mayor(cm)</label>
            <input type="number" class="form-control" id="txtFondoMayorRincon" v-model="fondoMayorRincon" aria-describedby="alto" placeholder="Fondo"
              min="0" step="0.1">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="txtAnchoMenorRincon">Ancho menor(cm)</label>
            <input type="number" class="form-control" id="txtAnchoMenorRincon" v-model="anchoMenorRincon" aria-describedby="ancho" placeholder="Ancho"
              min="0" step="0.1">
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="txtFondoMenorRincon">Fondo menor(cm)</label>
            <input type="number" class="form-control" id="txtFondoMenorRincon" v-model="fondoMenorRincon" aria-describedby="alto" placeholder="Fondo"
              min="0" step="0.1">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-12">
          <h5>Tipo Canteado</h5>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" v-model="tipoCanteado" id="tipoCanteadoOp1" :value="TIPO_CANTEADO_TODO">
            <label class="form-check-label" for="tipoCanteadoOp1">Todo canteado</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio" v-model="tipoCanteado" id="tipoCanteadoOp2" :value="TIPO_CANTEADO_PERSONALIZADO">
            <label class="form-check-label" for="tipoCanteadoOp2">Canteado personalizado</label>
          </div>
        </div>
      </div>

      <!-- PIEZAS Y CANTEADO -->
      <div class="row mt-2">
        <!-- CASCO ALTO -->
        <div class="col-md-8 offset-md-2" v-if="mueble === 'Casco Alto'">
          <h4>Piezas Casco Alto y Canteado</h4>
          <ul class="list-group">
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Base</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO && !this.isGola">
                    <span>{{ CASCO_ALTO.CANTOS.BASE.op2 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ CASCO_ALTO.CANTOS.BASE.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>2 - Costados</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_ALTO.CANTOS.COSTADO.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoCostados" id="cascoAltoCostadosOp1" :value="CASCO_ALTO.CANTOS.COSTADO.op1">
                      <label class="form-check-label" for="cascoAltoCostadosOp1">{{ CASCO_ALTO.CANTOS.COSTADO.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoCostados" id="cascoAltoCostadosOp2" :value="CASCO_ALTO.CANTOS.COSTADO.op2">
                      <label class="form-check-label" for="cascoAltoCostadosOp2">{{ CASCO_ALTO.CANTOS.COSTADO.op2 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Techo</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_ALTO.CANTOS.TECHO.op2 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ CASCO_ALTO.CANTOS.TECHO.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="numBaldas > 0">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>{{ numBaldas }} - Baldas</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_ALTO.CANTOS.BALDA.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoBaldas" id="cascoAltoBaldasOp1" :value="CASCO_ALTO.CANTOS.BALDA.op1">
                      <label class="form-check-label" for="cascoAltoBaldasOp1">{{ CASCO_ALTO.CANTOS.BALDA.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoBaldas" id="cascoAltoBaldasOp2" :value="CASCO_ALTO.CANTOS.BALDA.op2">
                      <label class="form-check-label" for="cascoAltoBaldasOp2">{{ CASCO_ALTO.CANTOS.BALDA.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoBaldas" id="cascoAltoBaldasOp3" :value="CASCO_ALTO.CANTOS.BALDA.op3">
                      <label class="form-check-label" for="cascoAltoBaldasOp3">{{ CASCO_ALTO.CANTOS.BALDA.op3 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="numDivisores > 0">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>{{ numDivisores }} - Divisores {{ posicionDivisor }}</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_ALTO.CANTOS.DIVISOR.op1 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ CASCO_ALTO.CANTOS.DIVISOR.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="this.isTrasera">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Trasera</span>
                </div>
                <div v-if="!this.isCanal" class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_ALTO.CANTOS.TRASERA.op9 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoTrasera" id="cascoAltoTraseraOp1" :value="CASCO_ALTO.CANTOS.TRASERA.op1">
                      <label class="form-check-label" for="cascoAltoTraseraOp1">{{ CASCO_ALTO.CANTOS.TRASERA.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoTrasera" id="cascoAltoTraseraOp2" :value="CASCO_ALTO.CANTOS.TRASERA.op2">
                      <label class="form-check-label" for="cascoAltoTraseraOp2">{{ CASCO_ALTO.CANTOS.TRASERA.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoTrasera" id="cascoAltoTraseraOp3" :value="CASCO_ALTO.CANTOS.TRASERA.op3">
                      <label class="form-check-label" for="cascoAltoTraseraOp3">{{ CASCO_ALTO.CANTOS.TRASERA.op3 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoTrasera" id="cascoAltoTraseraOp4" :value="CASCO_ALTO.CANTOS.TRASERA.op4">
                      <label class="form-check-label" for="cascoAltoTraseraOp4">{{ CASCO_ALTO.CANTOS.TRASERA.op4 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoTrasera" id="cascoAltoTraseraOp5" :value="CASCO_ALTO.CANTOS.TRASERA.op5">
                      <label class="form-check-label" for="cascoAltoTraseraOp5">{{ CASCO_ALTO.CANTOS.TRASERA.op5 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoTrasera" id="cascoAltoTraseraOp6" :value="CASCO_ALTO.CANTOS.TRASERA.op6">
                      <label class="form-check-label" for="cascoAltoTraseraOp6">{{ CASCO_ALTO.CANTOS.TRASERA.op6 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoTrasera" id="cascoAltoTraseraOp7" :value="CASCO_ALTO.CANTOS.TRASERA.op7">
                      <label class="form-check-label" for="cascoAltoTraseraOp7">{{ CASCO_ALTO.CANTOS.TRASERA.op7 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoTrasera" id="cascoAltoTraseraOp8" :value="CASCO_ALTO.CANTOS.TRASERA.op8">
                      <label class="form-check-label" for="cascoAltoTraseraOp8">{{ CASCO_ALTO.CANTOS.TRASERA.op8 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoAltoTrasera" id="cascoAltoTraseraOp9" :value="CASCO_ALTO.CANTOS.TRASERA.op9">
                      <label class="form-check-label" for="cascoAltoTraseraOp9">{{ CASCO_ALTO.CANTOS.TRASERA.op9 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- CASCO ALTO -->
        <!-- CASCO BAJO -->
        <div class="col-md-8 offset-md-2" v-if="mueble === 'Casco Bajo'">
          <h4>Piezas Casco Bajo y Canteado</h4>
          <ul class="list-group">
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Base</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_BAJO.CANTOS.BASE.op4 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoBase" id="cascoBajoBaseOp1" :value="CASCO_BAJO.CANTOS.BASE.op1">
                      <label class="form-check-label" for="cascoBajoBaseOp1">{{ CASCO_BAJO.CANTOS.BASE.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoBase" id="cascoBajoBaseOp2" :value="CASCO_BAJO.CANTOS.BASE.op2">
                      <label class="form-check-label" for="cascoBajoBaseOp2">{{ CASCO_BAJO.CANTOS.BASE.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoBase" id="cascoBajoBaseOp3" :value="CASCO_BAJO.CANTOS.BASE.op3">
                      <label class="form-check-label" for="cascoBajoBaseOp3">{{ CASCO_BAJO.CANTOS.BASE.op3 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>2 - Costados</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_BAJO.CANTOS.COSTADO.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoCostados" id="cascoBajoCostadosOp1" :value="CASCO_BAJO.CANTOS.COSTADO.op1">
                      <label class="form-check-label" for="cascoBajoCostadosOp1">{{ CASCO_BAJO.CANTOS.COSTADO.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoCostados" id="cascoBajoCostadosOp2" :value="CASCO_BAJO.CANTOS.COSTADO.op2">
                      <label class="form-check-label" for="cascoBajoCostadosOp2">{{ CASCO_BAJO.CANTOS.COSTADO.op2 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Techo</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_BAJO.CANTOS.TECHO.op2 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ CASCO_BAJO.CANTOS.TECHO.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="numBaldas > 0">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>{{ numBaldas }} - Baldas</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_BAJO.CANTOS.BALDA.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoBaldas" id="cascoBajoBaldasOp1" :value="CASCO_BAJO.CANTOS.BALDA.op1">
                      <label class="form-check-label" for="cascoBajoBaldasOp1">{{ CASCO_BAJO.CANTOS.BALDA.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoBaldas" id="cascoBajoBaldasOp2" :value="CASCO_BAJO.CANTOS.BALDA.op2">
                      <label class="form-check-label" for="cascoBajoBaldasOp2">{{ CASCO_BAJO.CANTOS.BALDA.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoBaldas" id="cascoBajoBaldasOp3" :value="CASCO_BAJO.CANTOS.BALDA.op3">
                      <label class="form-check-label" for="cascoBajoBaldasOp3">{{ CASCO_BAJO.CANTOS.BALDA.op3 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="numDivisores > 0">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>{{ numDivisores }} - Divisores {{ posicionDivisor }}</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_BAJO.CANTOS.DIVISOR.op1 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ CASCO_BAJO.CANTOS.DIVISOR.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="this.isTrasera">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Trasera</span>
                </div>
                <div v-if="!this.isCanal" class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CASCO_BAJO.CANTOS.TRASERA.op9 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoTrasera" id="cascoBajoTraseraOp1" :value="CASCO_BAJO.CANTOS.TRASERA.op1">
                      <label class="form-check-label" for="cascoBajoTraseraOp1">{{ CASCO_BAJO.CANTOS.TRASERA.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoTrasera" id="cascoBajoTraseraOp2" :value="CASCO_BAJO.CANTOS.TRASERA.op2">
                      <label class="form-check-label" for="cascoBajoTraseraOp2">{{ CASCO_BAJO.CANTOS.TRASERA.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoTrasera" id="cascoBajoTraseraOp3" :value="CASCO_BAJO.CANTOS.TRASERA.op3">
                      <label class="form-check-label" for="cascoBajoTraseraOp3">{{ CASCO_BAJO.CANTOS.TRASERA.op3 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoTrasera" id="cascoBajoTraseraOp4" :value="CASCO_BAJO.CANTOS.TRASERA.op4">
                      <label class="form-check-label" for="cascoBajoTraseraOp4">{{ CASCO_BAJO.CANTOS.TRASERA.op4 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoTrasera" id="cascoBajoTraseraOp5" :value="CASCO_BAJO.CANTOS.TRASERA.op5">
                      <label class="form-check-label" for="cascoBajoTraseraOp5">{{ CASCO_BAJO.CANTOS.TRASERA.op5 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoTrasera" id="cascoBajoTraseraOp6" :value="CASCO_BAJO.CANTOS.TRASERA.op6">
                      <label class="form-check-label" for="cascoBajoTraseraOp6">{{ CASCO_BAJO.CANTOS.TRASERA.op6 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoTrasera" id="cascoBajoTraseraOp7" :value="CASCO_BAJO.CANTOS.TRASERA.op7">
                      <label class="form-check-label" for="cascoBajoTraseraOp7">{{ CASCO_BAJO.CANTOS.TRASERA.op7 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoTrasera" id="cascoBajoTraseraOp8" :value="CASCO_BAJO.CANTOS.TRASERA.op8">
                      <label class="form-check-label" for="cascoBajoTraseraOp8">{{ CASCO_BAJO.CANTOS.TRASERA.op8 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCascoBajoTrasera" id="cascoBajoTraseraOp9" :value="CASCO_BAJO.CANTOS.TRASERA.op9">
                      <label class="form-check-label" for="cascoBajoTraseraOp9">{{ CASCO_BAJO.CANTOS.TRASERA.op9 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- CASCO BAJO -->
        <!-- RINCON -->
        <div class="col-md-8 offset-md-2" v-if="mueble === 'Rincón'">
          <h4>Piezas Rincón y Canteado</h4>
          <ul class="list-group">
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Base mayor</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ RINCON.CANTOS.BASE_MAYOR.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconBaseMayor" id="rinconBaseMayorOp1" :value="RINCON.CANTOS.BASE_MAYOR.op1">
                      <label class="form-check-label" for="rinconBaseMayorOp1">{{ RINCON.CANTOS.BASE_MAYOR.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconBaseMayor" id="rinconBaseMayorOp2" :value="RINCON.CANTOS.BASE_MAYOR.op2">
                      <label class="form-check-label" for="rinconBaseMayorOp2">{{ RINCON.CANTOS.BASE_MAYOR.op2 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Base menor</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ RINCON.CANTOS.BASE_MENOR.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconBaseMenor" id="rinconBaseMenorOp1" :value="RINCON.CANTOS.BASE_MAYOR.op1">
                      <label class="form-check-label" for="rinconBaseMenorOp1">{{ RINCON.CANTOS.BASE_MENOR.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconBaseMenor" id="rinconBaseMenorOp2" :value="RINCON.CANTOS.BASE_MENOR.op2">
                      <label class="form-check-label" for="rinconBaseMenorOp2">{{ RINCON.CANTOS.BASE_MENOR.op2 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Costado mayor</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ RINCON.CANTOS.COSTADO.op2 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ RINCON.CANTOS.COSTADO.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Costado menor</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ RINCON.CANTOS.COSTADO.op2 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ RINCON.CANTOS.COSTADO.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Techo mayor</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ RINCON.CANTOS.TECHO_MAYOR.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTechoMayor" id="rinconTechoMayorOp1" :value="RINCON.CANTOS.BASE_MAYOR.op1">
                      <label class="form-check-label" for="rinconTechoMayorOp1">{{ RINCON.CANTOS.TECHO_MAYOR.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTechoMayor" id="rinconTechoMayorOp2" :value="RINCON.CANTOS.BASE_MENOR.op2">
                      <label class="form-check-label" for="rinconTechoMayorOp2">{{ RINCON.CANTOS.TECHO_MAYOR.op2 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Techo menor</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ RINCON.CANTOS.TECHO_MENOR.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTechoMenor" id="rinconTechoMenorOp1" :value="RINCON.CANTOS.TECHO_MENOR.op1">
                      <label class="form-check-label" for="rinconTechoMenorOp1">{{ RINCON.CANTOS.TECHO_MENOR.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTechoMenor" id="rinconTechoMenorOp2" :value="RINCON.CANTOS.TECHO_MENOR.op2">
                      <label class="form-check-label" for="rinconTechoMenorOp2">{{ RINCON.CANTOS.TECHO_MENOR.op2 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="numBaldas > 0">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>{{ numBaldas }} - Balda Mayor</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ RINCON.CANTOS.BALDA_MAYOR.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconBaldaMayor" id="rinconBaldaMayorOp1" :value="RINCON.CANTOS.BALDA_MAYOR.op1">
                      <label class="form-check-label" for="rinconBaldaMayorOp1">{{ RINCON.CANTOS.BALDA_MAYOR.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconBaldaMayor" id="rinconBaldaMayorOp2" :value="RINCON.CANTOS.BALDA_MAYOR.op2">
                      <label class="form-check-label" for="rinconBaldaMayorOp2">{{ RINCON.CANTOS.BALDA_MAYOR.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconBaldaMayor" id="rinconBaldaMayorOp3" :value="RINCON.CANTOS.BALDA_MAYOR.op3">
                      <label class="form-check-label" for="rinconBaldaMayorOp3">{{ RINCON.CANTOS.BALDA_MAYOR.op3 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="numBaldas > 0">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>{{ numBaldas }} - Balda Menor</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ RINCON.CANTOS.BALDA_MENOR.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconBaldaMenor" id="rinconBaldaMenorOp1" :value="RINCON.CANTOS.BALDA_MENOR.op1">
                      <label class="form-check-label" for="rinconBaldaMenorOp1">{{ RINCON.CANTOS.BALDA_MENOR.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconBaldaMenor" id="rinconBaldaMenorOp2" :value="RINCON.CANTOS.BALDA_MENOR.op2">
                      <label class="form-check-label" for="rinconBaldaMenorOp2">{{ RINCON.CANTOS.BALDA_MENOR.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconBaldaMenor" id="rinconBaldaMenorOp3" :value="RINCON.CANTOS.BALDA_MENOR.op3">
                      <label class="form-check-label" for="rinconBaldaMenorOp3">{{ RINCON.CANTOS.BALDA_MENOR.op3 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Regleta</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ RINCON.CANTOS.REGLETA.op1 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ RINCON.CANTOS.REGLETA.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="this.isTrasera">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>2 - Traseras</span>
                </div>
                <div v-if="!this.isCanal" class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ RINCON.CANTOS.TRASERA.op9 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTrasera" id="rinconTraseraOp1" :value="RINCON.CANTOS.TRASERA.op1">
                      <label class="form-check-label" for="rinconTraseraOp1">{{ RINCON.CANTOS.TRASERA.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTrasera" id="rinconTraseraOp2" :value="RINCON.CANTOS.TRASERA.op2">
                      <label class="form-check-label" for="rinconTraseraOp2">{{ RINCON.CANTOS.TRASERA.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTrasera" id="rinconTraseraOp3" :value="RINCON.CANTOS.TRASERA.op3">
                      <label class="form-check-label" for="rinconTraseraOp3">{{ RINCON.CANTOS.TRASERA.op3 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTrasera" id="rinconTraseraOp4" :value="RINCON.CANTOS.TRASERA.op4">
                      <label class="form-check-label" for="rinconTraseraOp4">{{ RINCON.CANTOS.TRASERA.op4 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTrasera" id="rinconTraseraOp5" :value="RINCON.CANTOS.TRASERA.op5">
                      <label class="form-check-label" for="rinconTraseraOp5">{{ RINCON.CANTOS.TRASERA.op5 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTrasera" id="rinconTraseraOp6" :value="RINCON.CANTOS.TRASERA.op6">
                      <label class="form-check-label" for="rinconTraseraOp6">{{ RINCON.CANTOS.TRASERA.op6 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTrasera" id="rinconTraseraOp7" :value="RINCON.CANTOS.TRASERA.op7">
                      <label class="form-check-label" for="rinconTraseraOp7">{{ RINCON.CANTOS.TRASERA.op7 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTrasera" id="rinconTraseraOp8" :value="RINCON.CANTOS.TRASERA.op8">
                      <label class="form-check-label" for="rinconTraseraOp8">{{ RINCON.CANTOS.TRASERA.op8 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosRinconTrasera" id="rinconTraseraOp9" :value="RINCON.CANTOS.TRASERA.op9">
                      <label class="form-check-label" for="rinconTraseraOp9">{{ RINCON.CANTOS.TRASERA.op9 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- RINCON -->
        <!-- FREGADERO -->
        <div class="col-md-8 offset-md-2" v-if="mueble === 'Fregadero'">
          <h4>Piezas Fregadero y Canteado</h4>
          <ul class="list-group">
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Base</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ FREGADERO.CANTOS.BASE.op4 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosFregaderoBase" id="fregaderoBaseOp1" :value="FREGADERO.CANTOS.BASE.op1">
                      <label class="form-check-label" for="fregaderoBaseOp1">{{ FREGADERO.CANTOS.BASE.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosFregaderoBase" id="fregaderoBaseOp2" :value="FREGADERO.CANTOS.BASE.op2">
                      <label class="form-check-label" for="fregaderoBaseOp2">{{ FREGADERO.CANTOS.BASE.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosFregaderoBase" id="fregaderoBaseOp3" :value="FREGADERO.CANTOS.BASE.op3">
                      <label class="form-check-label" for="fregaderoBaseOp3">{{ FREGADERO.CANTOS.BASE.op3 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>2 - Costados</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ FREGADERO.CANTOS.COSTADO.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosFregaderoCostados" id="fregaderoCostadosOp1" :value="FREGADERO.CANTOS.COSTADO.op1">
                      <label class="form-check-label" for="fregaderoBaseOp1">{{ FREGADERO.CANTOS.COSTADO.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosFregaderoCostados" id="fregaderoCostadosOp2" :value="FREGADERO.CANTOS.COSTADO.op2">
                      <label class="form-check-label" for="fregaderoCostadosOp2">{{ FREGADERO.CANTOS.COSTADO.op2 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>2 - Barras de {{ FREGADERO.BARRA_ALTURA }} cm</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ FREGADERO.CANTOS.BARRA.op1 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ FREGADERO.CANTOS.BARRA.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Tope de {{ FREGADERO.TOPE_ALTURA }} cm</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ FREGADERO.CANTOS.TOPE.op1 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ FREGADERO.CANTOS.TOPE.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- FREGADERO -->
        <!-- PLACA -->
        <div class="col-md-8 offset-md-2" v-if="mueble === 'Placa'">
          <h4>Piezas Placa y Canteado</h4>
          <ul class="list-group">
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Base</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ PLACA.CANTOS.BASE.op4 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPlacaBase" id="placaBaseOp1" :value="PLACA.CANTOS.BASE.op1">
                      <label class="form-check-label" for="placaBaseOp1">{{ PLACA.CANTOS.BASE.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPlacaBase" id="placaBaseOp2" :value="PLACA.CANTOS.BASE.op2">
                      <label class="form-check-label" for="placaBaseOp2">{{ PLACA.CANTOS.BASE.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPlacaBase" id="placaBaseOp3" :value="PLACA.CANTOS.BASE.op3">
                      <label class="form-check-label" for="placaBaseOp3">{{ PLACA.CANTOS.BASE.op3 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>2 - Costados</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ PLACA.CANTOS.COSTADO.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPlacaCostados" id="placaCostadosOp1" :value="PLACA.CANTOS.COSTADO.op1">
                      <label class="form-check-label" for="placaCostadosOp1">{{ PLACA.CANTOS.COSTADO.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPlacaCostados" id="placaCostadosOp2" :value="PLACA.CANTOS.COSTADO.op2">
                      <label class="form-check-label" for="placaCostadosOp2">{{ PLACA.CANTOS.COSTADO.op2 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>2 - Barras de {{ PLACA.BARRA_ALTURA }} cm</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ PLACA.CANTOS.BARRA.op1 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ PLACA.CANTOS.BARRA.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- PLACA -->
        <!-- CAJONERA -->
        <div class="col-md-8 offset-md-2" v-if="mueble === 'Cajonera'">
          <h4>Piezas Cajonera y Canteado</h4>
          <ul class="list-group">
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Base</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CAJONERA.CANTOS.BASE.op4 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCajoneraBase" id="cajoneraBaseOp1" :value="CAJONERA.CANTOS.BASE.op1">
                      <label class="form-check-label" for="cajoneraBaseOp1">{{ CAJONERA.CANTOS.BASE.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCajoneraBase" id="cajoneraBaseOp2" :value="CAJONERA.CANTOS.BASE.op2">
                      <label class="form-check-label" for="cajoneraBaseOp2">{{ CAJONERA.CANTOS.BASE.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCajoneraBase" id="cajoneraBaseOp3" :value="CAJONERA.CANTOS.BASE.op3">
                      <label class="form-check-label" for="cajoneraBaseOp3">{{ CAJONERA.CANTOS.BASE.op3 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>2 - Costados</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CAJONERA.CANTOS.COSTADO.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCajoneraCostados" id="cajoneraCostadosOp1" :value="CAJONERA.CANTOS.COSTADO.op1">
                      <label class="form-check-label" for="cajoneraCostadosOp1">{{ CAJONERA.CANTOS.COSTADO.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosCajoneraCostados" id="cajoneraCostadosOp2" :value="CAJONERA.CANTOS.COSTADO.op2">
                      <label class="form-check-label" for="cajoneraCostadosOp2">{{ CAJONERA.CANTOS.COSTADO.op2 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>2 - Barras de {{ CAJONERA.BARRA_ALTURA }} cm</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ CAJONERA.CANTOS.BARRA.op1 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ CAJONERA.CANTOS.BARRA.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- CAJONERA -->
        <!-- ESCURREPLATOS -->
        <div class="col-md-8 offset-md-2" v-if="mueble === 'Escurreplatos'">
          <h4>Piezas Escurreplatos y Canteado</h4>
          <ul class="list-group">
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>2 - Costados</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ ESCURREPLATOS.CANTOS.COSTADO.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosEscurreplatosCostados" id="escurreplatosCostadosOp1" :value="CASCO_ALTO.CANTOS.COSTADO.op1">
                      <label class="form-check-label" for="escurreplatosCostadosOp1">{{ ESCURREPLATOS.CANTOS.COSTADO.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosEscurreplatosCostados" id="escurreplatosCostadosOp2" :value="CASCO_ALTO.CANTOS.COSTADO.op2">
                      <label class="form-check-label" for="escurreplatosCostadosOp2">{{ ESCURREPLATOS.CANTOS.COSTADO.op2 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Techo</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ ESCURREPLATOS.CANTOS.TECHO.op2 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ ESCURREPLATOS.CANTOS.TECHO.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item" v-if="numBaldas > 0">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>{{ numBaldas }} - Baldas</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ ESCURREPLATOS.CANTOS.BALDA.op3 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosEscurreplatosBaldas" id="escurreplatosBaldasOp1" :value="ESCURREPLATOS.CANTOS.BALDA.op1">
                      <label class="form-check-label" for="escurreplatosBaldasOp1">{{ ESCURREPLATOS.CANTOS.BALDA.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosEscurreplatosBaldas" id="escurreplatosBaldasOp2" :value="ESCURREPLATOS.CANTOS.BALDA.op2">
                      <label class="form-check-label" for="escurreplatosBaldasOp2">{{ ESCURREPLATOS.CANTOS.BALDA.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosEscurreplatosBaldas" id="escurreplatosBaldasOp3" :value="ESCURREPLATOS.CANTOS.BALDA.op3">
                      <label class="form-check-label" for="escurreplatosBaldasOp3">{{ ESCURREPLATOS.CANTOS.BALDA.op3 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>1 - Trasera</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ ESCURREPLATOS.CANTOS.TRASERA.op1 }}</span>
                  </template>
                  <template v-else>
                    <span>{{ ESCURREPLATOS.CANTOS.TRASERA.op1 }}</span>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- ESCURREPLATOS -->
        <!-- PIEZA LIBRE -->
        <div class="col-md-8 offset-md-2" v-if="mueble === 'Pieza Libre'">
          <h4>Canteado Pieza Libre</h4>
          <ul class="list-group">
            <li class="list-group-item">
              <div class="row">
                <div class="col-sm-4 col-md-4">
                  <span>{{ nombrePiezaLibre !== '' ? nombrePiezaLibre : 'Pieza' }}</span>
                </div>
                <div class="col-sm-8 col-md-8">
                  <template v-if="this.tipoCanteado == TIPO_CANTEADO_TODO">
                    <span>{{ PIEZA_LIBRE.CANTOS.op9 }}</span>
                  </template>
                  <template v-else>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPiezaLibre" id="piezaLibreOp1" :value="PIEZA_LIBRE.CANTOS.op1">
                      <label class="form-check-label" for="piezaLibreOp1">{{ PIEZA_LIBRE.CANTOS.op1 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPiezaLibre" id="piezaLibreOp2" :value="PIEZA_LIBRE.CANTOS.op2">
                      <label class="form-check-label" for="piezaLibreOp2">{{ PIEZA_LIBRE.CANTOS.op2 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPiezaLibre" id="piezaLibreOp3" :value="PIEZA_LIBRE.CANTOS.op3">
                      <label class="form-check-label" for="piezaLibreOp3">{{ PIEZA_LIBRE.CANTOS.op3 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPiezaLibre" id="piezaLibreOp4" :value="PIEZA_LIBRE.CANTOS.op4">
                      <label class="form-check-label" for="piezaLibreOp4">{{ PIEZA_LIBRE.CANTOS.op4 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPiezaLibre" id="piezaLibreOp5" :value="PIEZA_LIBRE.CANTOS.op5">
                      <label class="form-check-label" for="piezaLibreOp5">{{ PIEZA_LIBRE.CANTOS.op5 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPiezaLibre" id="piezaLibreOp6" :value="PIEZA_LIBRE.CANTOS.op6">
                      <label class="form-check-label" for="piezaLibreOp6">{{ PIEZA_LIBRE.CANTOS.op6 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPiezaLibre" id="piezaLibreOp7" :value="PIEZA_LIBRE.CANTOS.op7">
                      <label class="form-check-label" for="piezaLibreOp7">{{ PIEZA_LIBRE.CANTOS.op7 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPiezaLibre" id="piezaLibreOp8" :value="PIEZA_LIBRE.CANTOS.op8">
                      <label class="form-check-label" for="piezaLibreOp8">{{ PIEZA_LIBRE.CANTOS.op8 }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="radio" v-model="cantosPiezaLibre" id="piezaLibreOp9" :value="PIEZA_LIBRE.CANTOS.op9">
                      <label class="form-check-label" for="piezaLibreOp9">{{ PIEZA_LIBRE.CANTOS.op9 }}</label>
                    </div>
                  </template>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- PIEZA LIBRE -->
      </div>
      <!-- PIEZAS Y CANTEADO -->

      <!-- BOTON AÑADIR DESPIECE -->
      <div class="row mt-3">
        <div class="col-md-12">
          <div class="form-group">
            <button type="button" class="btn btn-primary" @click="anadirDespiece">Añadir Despiece</button>
          </div>
        </div>
      </div>
      <!-- BOTON AÑADIR DESPIECE -->

      <hr>

      <div class="row mb-3">
        <!-- MUEBLES -->
        <div class="col-md-12 text-center">
          <h4 id="tooltipMuebleActualizado" data-toggle="tooltip" data-placement="top" data-title="¡Mueble actualizado!">Muebles</h4>
        </div>
        <div class="col-md-12">
          <ul>
            <li class="col-md-3" v-for="(mueble, indice) in this.mueblesDespiece" :key="indice" style="padding: 10px 10px;margin: 5px;border: 1px solid rgba(0,0,0,.125);">
              <div class="row">
                <div class="col-md-4">
                  <button type="button" class="btn btn-warning btn-sm" data-toggle="modal" data-target="#editarMuebleModal" style="margin-bottom: 3px" @click="editarMueble(indice)">Editar</button>
                  <button type="button" class="btn btn-danger btn-sm" @click="eliminarMueble(indice)">Eliminar</button>
                </div>
                <div class="col-md-8">
                  <span class="txtNombreMuebleAnadido">{{ mueble.mueble }}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- MUEBLES -->

        <!-- MODAL EDITAR MUEBLE -->
        <div class="modal fade" id="editarMuebleModal" tabindex="-1" role="dialog" aria-labelledby="editarMuebleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="editarMuebleModalLabel">{{ muebleAEditar.mueble }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <form>
                  <div class="row" v-for="(pieza, indice) in this.muebleAEditar.piezas" :key="indice">
                    <div class="col-sm-12">
                      <span style="font-size: 20px">{{ pieza.nombre }}</span>
                    </div>
                    <div class="form-group col-sm-3">
                      <label for="txtAltoPiezaEditada">Alto(cm)</label>
                      <input v-if="muebleAEditar.piezas.length > 1" type="number" class="form-control" id="txtAltoPiezaEditada" v-model="pieza.ancho" aria-describedby="alto" placeholder="Alto" min="0" step="0.1">
                      <input v-else type="number" class="form-control" id="txtAltoPiezaEditada" v-model="pieza.alto" aria-describedby="alto" placeholder="Alto" min="0" step="0.1">
                    </div>
                    <div class="form-group col-sm-3">
                      <label for="txtAnchoPiezaEditada">Ancho(cm)</label>
                      <input v-if="muebleAEditar.piezas.length > 1" type="number" class="form-control" id="txtAnchoPiezaEditada" v-model="pieza.alto" aria-describedby="ancho" placeholder="Ancho" min="0" step="0.1">
                      <input v-else type="number" class="form-control" id="txtAnchoPiezaEditada" v-model="pieza.ancho" aria-describedby="ancho" placeholder="Ancho" min="0" step="0.1">
                    </div>
                    <div class="form-group col-sm-6">
                      <label for="sltCanteadoPiezaEditada">Canteado</label>
                      <select class="form-control" id="sltCanteadoPiezaEditada" v-model="pieza.canteado">
                        <option v-for="(canteado, indice) in opcionesCanteadoPiezaLibre" :key="indice">{{ canteado }}</option>
                      </select>
                    </div>
                  </div>
                </form>
                <form>
                  <div class="row" v-for="(pieza, indice) in this.muebleAEditar.traseras" :key="indice">
                    <div class="col-sm-12">
                      <span style="font-size: 20px">{{ pieza.nombre }}</span>
                    </div>
                    <div class="form-group col-sm-3">
                      <label for="txtAltoTraseraEditada">Alto(cm)</label>
                      <input type="number" class="form-control" id="txtAltoTraseraEditada" v-model="pieza.ancho" aria-describedby="alto" placeholder="Alto" min="0" step="0.1">
                    </div>
                    <div class="form-group col-sm-3">
                      <label for="txtAnchoTraseraEditada">Ancho(cm)</label>
                      <input type="number" class="form-control" id="txtAnchoTraseraEditada" v-model="pieza.alto" aria-describedby="ancho" placeholder="Ancho" min="0" step="0.1">
                    </div>
                    <div class="form-group col-sm-6">
                      <label for="sltCanteadoTraseraEditada">Canteado</label>
                      <select class="form-control" id="sltCanteadoTraseraEditada" v-model="pieza.canteado">
                        <option v-for="(canteado, indice) in opcionesCanteadoPiezaLibre" :key="indice">{{ canteado }}</option>
                      </select>
                    </div>
                  </div>
                </form>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                <button type="button" class="btn btn-primary" @click="guardarEdicionMueble()">Guardar</button>
              </div>
            </div>
          </div>
        </div>
        <!-- MODAL EDITAR MUEBLE -->
      </div>

      <div class="row mb-3">
        <!-- DESPIECE TALLER -->
        <div class="col-md-6 col-lg-6 mt-3">
          <div class="card card-body bg-light" v-if="despieceTaller">
            <div class="row">
              <div class="col-md-8 offset-md-0 col-sm-6 offset-sm-3">
                <h4>Despiece Taller</h4>
              </div>
              <div class="col-md-4 col-sm-3">
                <div class="form-group">
                  <button id="btnCopiarDespieceTaller" type="button" class="btn btn-success" @click="copiarDespiece('txtDespieceTaller')" data-toggle="tooltip" data-placement="top" data-title="¡Copiado al portapapeles!">Copiar</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h5>Total piezas: {{ contadorPiezasTaller }}</h5>
              </div>
            </div>
            <pre id="txtDespieceTaller">{{ despieceTaller }}</pre>
          </div>
        </div>
        <!-- DESPIECE TALLER -->
        <!-- DESPIECE PEDIDO -->
        <div class="col-md-6 col-lg-6 mt-3">
          <div class="card card-body bg-light" v-if="despiecePedido">
            <div class="row">
              <div class="col-md-8 offset-md-0 col-sm-6 offset-sm-3">
                <h4>Despiece Pedido</h4>
              </div>
              <div class="col-md-4 col-sm-3">
                <div class="form-group">
                  <button id="btnCopiarDespiecePedido" type="button" class="btn btn-success" @click="copiarDespiece('txtDespiecePedido')" data-toggle="tooltip" data-placement="top" data-title="¡Copiado al portapapeles!">Copiar</button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h5>Total piezas: {{ contadorPiezasPedido }}</h5>
              </div>
            </div>
            <pre id="txtDespiecePedido">{{ despiecePedido }}</pre>
          </div>
        </div>
        <!-- DESPIECE PEDIDO -->
      </div>

    </div>
  </div>
</template>

<script>
import DATA from './data_muebles.js'

export default {
  name: 'app',
  data () {
    return {
      TITLE: 'Despiece - DIJUL',
      MUEBLES: ['Casco Alto', 'Casco Bajo', 'Rincón', 'Fregadero', 'Placa', 'Cajonera', 'Escurreplatos', 'Pieza Libre'],
      GROSORES_MUEBLE: [1.6, 1.9, 1.0], // cm
      GROSOR_TRASERA: 1, // cm
      HOLGURA_BALDA: 0.2, // cm
      REDUCCION_BALDA: 0.5, // cm
      REDUCCION_DIVISOR: 0.5, // cm
      REDUCCION_GROSOR_TRASERA: 1, // cm
      REDUCCION_BASE: 5, // cm
      REDUCCION_CANAL: 3, // cm
      AUMENTO_TRASERA_CON_CANAL: 1, // cm
      REDUCCION_TRASERA_SIN_CANAL: 0.2, // cm
      REDUCCION_FONDO_GOLA: 2.3, // cm

      TIPO_CANTEADO_TODO: 1,
      TIPO_CANTEADO_PERSONALIZADO: 2,

      mueble: 'Casco Alto',
      grosorMueble: 1.9,
      altoMueble: 70,
      anchoMueble: 60,
      fondoMueble: 58,
      anchoMayorRincon: 100,
      anchoMenorRincon: 90,
      fondoMayorRincon: 58,
      fondoMenorRincon: 58,
      altoRincon: 70,
      numBaldas: 1,
      numPiezaLibre: 1,
      nombrePiezaLibre: '',
      numDivisores: 0,
      isHidrofugo: false,
      isCanal: false,
      isTrasera: false,
      isGola: false,
      tipoCanteado: 1,
      mueblesDespiece: [],
      piezasDespiecePedido: {},
      piezasDespiecePedidoEstructura: {
        'hidrofugo': {
          'grosor19': {
            'grosor': 19,
            'piezas': []
          },
          'grosor16': {
            'grosor': 16,
            'piezas': []
          },
          'grosor10': {
            'grosor': 10,
            'piezas': []
          },
        },
        'noHidrofugo': {
          'grosor19': {
            'grosor': 19,
            'piezas': []
          },
          'grosor16': {
            'grosor': 16,
            'piezas': []
          },
          'grosor10': {
            'grosor': 10,
            'piezas': []
          },
        }
      },
      despieceTaller: '',
      despiecePedido: '',
      contadorPiezasTaller: 0,
      contadorPiezasPedido: 0,

      CASCO_ALTO: DATA.CASCO_ALTO,
      cantosCascoAltoBase: '',
      cantosCascoAltoCostados: '',
      cantosCascoAltoTecho: '',
      cantosCascoAltoBaldas: '',
      cantosCascoAltoDivisores: '',
      cantosCascoAltoTrasera: '',

      CASCO_BAJO: DATA.CASCO_BAJO,
      cantosCascoBajoBase: '',
      cantosCascoBajoCostados: '',
      cantosCascoBajoTecho: '',
      cantosCascoBajoBaldas: '',
      cantosCascoBajoDivisores: '',
      cantosCascoBajoTrasera: '',

      RINCON: DATA.RINCON,
      cantosRinconBaseMayor: '',
      cantosRinconBaseMenor: '',
      cantosRinconCostados: '',
      cantosRinconTechoMayor: '',
      cantosRinconTechoMenor: '',
      cantosRinconBaldaMayor: '',
      cantosRinconBaldaMenor: '',
      cantosRinconRegleta: '',
      cantosRinconTrasera: '',

      FREGADERO: DATA.FREGADERO,
      cantosFregaderoBase: '',
      cantosFregaderoCostados: '',
      cantosFregaderoBarras: '',
      cantosFregaderoTope: '',

      PLACA: DATA.PLACA,
      cantosPlacaBase: '',
      cantosPlacaCostados: '',
      cantosPlacaBarras: '',

      CAJONERA: DATA.CAJONERA,
      cantosCajoneraBase: '',
      cantosCajoneraCostados: '',
      cantosCajoneraBarras: '',

      ESCURREPLATOS: DATA.ESCURREPLATOS,
      cantosEscurreplatosCostados: '',
      cantosEscurreplatosTecho: '',
      cantosEscurreplatosBaldas: '',
      cantosEscurreplatosTrasera: '',

      PIEZA_LIBRE: DATA.PIEZA_LIBRE,
      cantosPiezaLibre: '',

      DIVISOR: DATA.DIVISOR,
      posicionDivisor: DATA.DIVISOR.POSICION.op1,
      ajusteDivisor: DATA.DIVISOR.AJUSTE.op1,

      muebleAEditar: {},
      opcionesCanteadoPiezaLibre: DATA.PIEZA_LIBRE.CANTOS,
    }
  },
  mounted(){
    this.seleccionarOpcionesTodoCanteado();
  },
  watch: {
    // Cuando marca trasera con canal, selecciono la opcion por defecto de canteado
    isCanal: function (isCanal) {
      if(isCanal){
        this.cantosCascoAltoTrasera = DATA.CASCO_ALTO.CANTOS.TRASERA.op1;
        this.cantosCascoBajoTrasera = DATA.CASCO_BAJO.CANTOS.TRASERA.op1;
        this.cantosRinconTrasera = DATA.RINCON.CANTOS.TRASERA.op1;
      }
    },
    // Cuando marca con gola, selecciono la opcion de canteado
    isGola: function (isGola) {
      if(this.tipoCanteado == this.TIPO_CANTEADO_TODO){
        this.cantosCascoAltoBase = DATA.CASCO_ALTO.CANTOS.BASE.op2;
        if(isGola) {
          this.cantosCascoAltoBase = DATA.CASCO_ALTO.CANTOS.BASE.op1;
        }
      }
    },
    // Cuando cambia el tipo de canteado, selecciono la opcion por defecto de cada pieza
    tipoCanteado: function (tipoCanteado) {
      if(tipoCanteado == this.TIPO_CANTEADO_TODO){
        this.seleccionarOpcionesTodoCanteado();
      }else{
        this.seleccionarOpcionesCanteadoPersonalizado();
      }
    },
  },
  methods: {
    anadirDespiece() {
      switch (this.mueble) {
        case 'Casco Alto':
          this.calcularDespieceCascoAlto();
          break;

        case 'Casco Bajo':
          this.calcularDespieceCascoBajo();
          break;

        case 'Rincón':
          this.calcularDespieceRincon();
          break;

        case 'Fregadero':
          this.calcularDespieceFregadero();
          break;

        case 'Placa':
          this.calcularDespiecePlaca();
          break;

        case 'Cajonera':
          this.calcularDespieceCajonera();
          break;

        case 'Escurreplatos':
          this.calcularDespieceEscurreplatos();
          break;

        case 'Pieza Libre':
          this.calcularDespiecePiezaLibre();
          break;
      }
      // Muestro el despiece para todos los muebles añadidos
      this.mostrarDespieceTaller();
      this.mostrarDespiecePedido();
    },
    calcularDespieceCascoAlto() {
      let hidrofugo = this.isHidrofugo ? '(HID) ' : '';
      let gola = this.isGola ? '(GOLA) ' : '';
      let reduccionCanal = this.isCanal ? this.REDUCCION_CANAL : 0;
      let reduccionGrosorTrasera = this.isTrasera && !this.isCanal ? this.REDUCCION_GROSOR_TRASERA : 0;
      let reduccionTrasera = this.isCanal ? ((2 * this.grosorMueble) - this.AUMENTO_TRASERA_CON_CANAL) : (this.REDUCCION_TRASERA_SIN_CANAL);
      let reduccionDivisor = this.ajusteDivisor == this.DIVISOR.AJUSTE.op2 ? this.REDUCCION_DIVISOR : 0; // Reduccion si es remetido
      let reduccionFondoGola = this.isGola ? this.REDUCCION_FONDO_GOLA : 0;
      let pieza = {};

      let cascoAlto = {
        'mueble': this.descripcionMueble('CASCO ALTO', this.anchoMueble, this.altoMueble, this.fondoMueble, this.grosorMueble, hidrofugo, gola),
        'grosorMueble': this.grosorMueble,
        'grosorTrasera': this.GROSOR_TRASERA,
        'hidrofugo': this.isHidrofugo,
        'piezas': []
      };

      // Añado la trasera al casco alto si esta marcado el check
      if(this.isTrasera){
        cascoAlto.traseras = [];
      }

      // Base
      pieza = {
        'nombre': 'Base',
        'cantidad': 1,
        'ancho': this.anchoMueble - (2 * this.grosorMueble),
        'alto': this.fondoMueble - reduccionGrosorTrasera - reduccionFondoGola,
        'canteado': this.cantosCascoAltoBase
      };
      cascoAlto.piezas.push(pieza);

      // Costados
      pieza = {
        'nombre': 'Costados',
        'cantidad': 2,
        'ancho': this.altoMueble,
        'alto': this.fondoMueble - reduccionGrosorTrasera,
        'canteado': this.cantosCascoAltoCostados
      };
      cascoAlto.piezas.push(pieza);

      // Techo
      pieza = {
        'nombre': 'Techo',
        'cantidad': 1,
        'ancho': this.anchoMueble - (2 * this.grosorMueble),
        'alto': this.fondoMueble - reduccionGrosorTrasera,
        'canteado': this.cantosCascoAltoTecho
      };
      cascoAlto.piezas.push(pieza);

      // Baldas
      if (this.numBaldas > 0) {
        pieza = {
          'nombre': 'Balda',
          'cantidad': parseInt(this.numBaldas),
          'ancho': this.redondearUnDecimal(this.anchoMueble - (2 * this.grosorMueble) - this.HOLGURA_BALDA),
          'alto': this.fondoMueble - reduccionGrosorTrasera - this.REDUCCION_BALDA - reduccionCanal,
          'canteado': this.cantosCascoAltoBaldas
        };
        cascoAlto.piezas.push(pieza);
      }

      // Divisores
      if (this.numDivisores > 0) {
        // Divisor Vertical
        if(this.posicionDivisor == this.DIVISOR.POSICION.op1){
          pieza = {
            'nombre': 'Divisor Vertical ' + this.ajusteDivisor,
            'cantidad': parseInt(this.numDivisores),
            'ancho': this.altoMueble,
            'alto': this.fondoMueble - reduccionGrosorTrasera - reduccionDivisor - reduccionCanal,
            'canteado': this.cantosCascoAltoDivisores
          };
          cascoAlto.piezas.push(pieza);
        }
        // Divisor Horizontal
        if(this.posicionDivisor == this.DIVISOR.POSICION.op2){
          pieza = {
            'nombre': 'Divisor Horizontal ' + this.ajusteDivisor,
            'cantidad': parseInt(this.numDivisores),
            'ancho': this.anchoMueble - (2 * this.grosorMueble),
            'alto': this.fondoMueble - reduccionGrosorTrasera - reduccionDivisor - reduccionCanal,
            'canteado': this.cantosCascoAltoDivisores
          };
          cascoAlto.piezas.push(pieza);
        }
      }

      // Trasera
      if(this.isTrasera){
        pieza = {
          'nombre': 'Trasera',
          'cantidad': 1,
          'ancho': this.anchoMueble - reduccionTrasera,
          'alto': this.altoMueble - reduccionTrasera,
          'canteado': this.cantosCascoAltoTrasera
        };
        cascoAlto.traseras.push(pieza);
      }

      this.mueblesDespiece.push(cascoAlto);
    },
    calcularDespieceCascoBajo() {
      let hidrofugo = this.isHidrofugo ? '(HID) ' : '';
      let gola = this.isGola ? '(GOLA) ' : '';
      let reduccionCanal = this.isCanal ? this.REDUCCION_CANAL : 0;
      let reduccionGrosorTrasera = this.isTrasera && !this.isCanal ? this.REDUCCION_GROSOR_TRASERA : 0;
      let reduccionTrasera = this.isCanal ? ((2 * this.grosorMueble) - this.AUMENTO_TRASERA_CON_CANAL) : (this.REDUCCION_TRASERA_SIN_CANAL);
      let reduccionDivisor = this.ajusteDivisor == this.DIVISOR.AJUSTE.op2 ? this.REDUCCION_DIVISOR : 0; // Reduccion si es remetido
      let reduccionFondoGola = this.isGola ? this.REDUCCION_FONDO_GOLA : 0;
      let pieza = {};

      let cascoBajo = {
        'mueble': this.descripcionMueble('CASCO BAJO', this.anchoMueble, this.altoMueble, this.fondoMueble, this.grosorMueble, hidrofugo, gola),
        'grosorMueble': this.grosorMueble,
        'grosorTrasera': this.GROSOR_TRASERA,
        'hidrofugo': this.isHidrofugo,
        'piezas': [],
      };

      // Añado la trasera al casco bajo si esta marcado el check
      if(this.isTrasera){
        cascoBajo.traseras = [];
      }

      // Base
      pieza = {
        'nombre': 'Base',
        'cantidad': 1,
        'ancho': this.anchoMueble,
        'alto': this.fondoMueble - reduccionGrosorTrasera,
        'canteado': this.cantosCascoBajoBase
      };
      cascoBajo.piezas.push(pieza);

      // Costados
      pieza = {
        'nombre': 'Costados',
        'cantidad': 2,
        'ancho': this.altoMueble - this.grosorMueble,
        'alto': this.fondoMueble - reduccionGrosorTrasera,
        'canteado': this.cantosCascoBajoCostados
      };
      cascoBajo.piezas.push(pieza);

      // Techo
      pieza = {
        'nombre': 'Techo',
        'cantidad': 1,
        'ancho': this.anchoMueble - (2 * this.grosorMueble),
        'alto': this.fondoMueble - reduccionGrosorTrasera - reduccionFondoGola,
        'canteado': this.cantosCascoBajoTecho
      };
      cascoBajo.piezas.push(pieza);

      // Baldas
      if (this.numBaldas > 0) {
        pieza = {
          'nombre': 'Balda',
          'cantidad': parseInt(this.numBaldas),
          'ancho': this.redondearUnDecimal(this.anchoMueble - (2 * this.grosorMueble) - this.HOLGURA_BALDA),
          'alto': this.fondoMueble - reduccionGrosorTrasera - this.REDUCCION_BALDA - reduccionCanal,
          'canteado': this.cantosCascoBajoBaldas
        };
        cascoBajo.piezas.push(pieza);
      }

      // Divisores
      if (this.numDivisores > 0) {
        // Divisor Vertical
        if(this.posicionDivisor == this.DIVISOR.POSICION.op1){
          pieza = {
            'nombre': 'Divisor Vertical ' + this.ajusteDivisor,
            'cantidad': parseInt(this.numDivisores),
            'ancho': this.altoMueble - (2 * this.grosorMueble),
            'alto': this.fondoMueble - reduccionGrosorTrasera - reduccionDivisor - reduccionCanal,
            'canteado': this.cantosCascoBajoDivisores
          };
          cascoBajo.piezas.push(pieza);
        }
        // Divisor Horizontal
        if(this.posicionDivisor == this.DIVISOR.POSICION.op2){
          pieza = {
            'nombre': 'Divisor Horizontal ' + this.ajusteDivisor,
            'cantidad': parseInt(this.numDivisores),
            'ancho': this.anchoMueble - (2 * this.grosorMueble),
            'alto': this.fondoMueble - reduccionGrosorTrasera - reduccionDivisor - reduccionCanal,
            'canteado': this.cantosCascoBajoDivisores
          };
          cascoBajo.piezas.push(pieza);
        }
      }

      // Trasera
      if(this.isTrasera){
        pieza = {
          'nombre': 'Trasera',
          'cantidad': 1,
          'ancho': this.anchoMueble - reduccionTrasera,
          'alto': this.altoMueble - reduccionTrasera,
          'canteado': this.cantosCascoBajoTrasera
        };
        cascoBajo.traseras.push(pieza);
      }

      this.mueblesDespiece.push(cascoBajo);
    },
    calcularDespieceRincon() {
      let hidrofugo = this.isHidrofugo ? '(HID) ' : '';
      let gola = this.isGola ? '(GOLA) ' : '';
      let reduccionCanal = this.isCanal ? this.REDUCCION_CANAL : 0;
      let reduccionGrosorTrasera = this.isTrasera && !this.isCanal ? this.REDUCCION_GROSOR_TRASERA : 0;
      let reduccionTrasera = this.isCanal ? ((2 * this.grosorMueble) - this.AUMENTO_TRASERA_CON_CANAL) : (this.REDUCCION_TRASERA_SIN_CANAL);
      let reduccionFondoGola = this.isGola ? this.REDUCCION_FONDO_GOLA : 0;
      let pieza = {};

      let rincon = {
        'mueble': hidrofugo + gola + 'RINCÓN' + ' DE ' + this.altoRincon + '(al) x ' + this.anchoMayorRincon + '(an) x ' + this.anchoMenorRincon + '(an) x ' + this.fondoMayorRincon + '(fon) x ' + this.fondoMenorRincon + '(fon) EN ' + this.grosorMueble * 10 + 'mm',
        'grosorMueble': this.grosorMueble,
        'grosorTrasera': this.GROSOR_TRASERA,
        'hidrofugo': this.isHidrofugo,
        'piezas': [],
      };

      // Añado la trasera al rincon si esta marcado el check
      if(this.isTrasera){
        rincon.traseras = [];
      }

      // Base mayor
      pieza = {
        'nombre': 'Base mayor',
        'cantidad': 1,
        'ancho': this.anchoMayorRincon - reduccionGrosorTrasera,
        'alto': this.fondoMayorRincon - reduccionGrosorTrasera,
        'canteado': this.cantosRinconBaseMayor
      };
      rincon.piezas.push(pieza);

      // Base menor
      pieza = {
        'nombre': 'Base menor',
        'cantidad': 1,
        'ancho': this.anchoMenorRincon - this.fondoMayorRincon,
        'alto': this.fondoMenorRincon - reduccionGrosorTrasera,
        'canteado': this.cantosRinconBaseMenor
      };
      rincon.piezas.push(pieza);

      // Costado mayor
      pieza = {
        'nombre': 'Costado mayor',
        'cantidad': 1,
        'ancho': this.altoRincon - this.grosorMueble,
        'alto': this.fondoMayorRincon - reduccionGrosorTrasera,
        'canteado': this.cantosRinconCostados
      };
      rincon.piezas.push(pieza);

      // Costado menor
      pieza = {
        'nombre': 'Costado menor',
        'cantidad': 1,
        'ancho': this.altoRincon - this.grosorMueble,
        'alto': this.fondoMenorRincon - reduccionGrosorTrasera,
        'canteado': this.cantosRinconCostados
      };
      rincon.piezas.push(pieza);

      // Techo mayor
      pieza = {
        'nombre': 'Techo mayor',
        'cantidad': 1,
        'ancho': this.anchoMayorRincon - reduccionGrosorTrasera,
        'alto': this.fondoMayorRincon - reduccionGrosorTrasera - reduccionFondoGola,
        'canteado': this.cantosRinconTechoMayor
      };
      rincon.piezas.push(pieza);

      // Techo menor
      pieza = {
        'nombre': 'Techo menor',
        'cantidad': 1,
        'ancho': this.anchoMenorRincon - this.fondoMayorRincon,
        'alto': this.fondoMenorRincon - reduccionGrosorTrasera - reduccionFondoGola,
        'canteado': this.cantosRinconTechoMenor
      };
      rincon.piezas.push(pieza);

      // Baldas
      if (this.numBaldas > 0) {
        // Balda mayor
        pieza = {
          'nombre': 'Balda mayor',
          'cantidad': parseInt(this.numBaldas),
          'ancho': this.redondearUnDecimal(this.anchoMayorRincon - reduccionGrosorTrasera - this.grosorMueble - this.HOLGURA_BALDA),
          'alto': this.fondoMayorRincon - reduccionGrosorTrasera - this.REDUCCION_BALDA - reduccionCanal,
          'canteado': this.cantosRinconBaldaMayor
        };
        rincon.piezas.push(pieza);

        // Balda menor
        pieza = {
          'nombre': 'Balda menor',
          'cantidad': parseInt(this.numBaldas),
          'ancho': this.redondearUnDecimal(this.anchoMenorRincon - this.fondoMayorRincon - reduccionGrosorTrasera - this.grosorMueble - this.HOLGURA_BALDA),
          'alto': this.fondoMenorRincon - reduccionGrosorTrasera - this.REDUCCION_BALDA - reduccionCanal,
          'canteado': this.cantosRinconBaldaMenor
        };
        rincon.piezas.push(pieza);
      }

      // Regleta
      pieza = {
        'nombre': 'Regleta',
        'cantidad': 1,
        'ancho': this.altoRincon - (2 * this.grosorMueble),
        'alto': this.RINCON.REGLETA_ANCHURA,
        'canteado': this.cantosRinconRegleta
      };
      rincon.piezas.push(pieza);

      // Trasera
      if(this.isTrasera){
        // Trasera mayor
        pieza = {
          'nombre': 'Trasera mayor',
          'cantidad': 1,
          'ancho': this.anchoMayorRincon - reduccionTrasera,
          'alto': this.altoRincon - reduccionTrasera,
          'canteado': this.cantosRinconTrasera
        };
        rincon.traseras.push(pieza);

        // Trasera menor
        pieza = {
          'nombre': 'Trasera menor',
          'cantidad': 1,
          'ancho': this.anchoMenorRincon - reduccionTrasera,
          'alto': this.altoRincon - reduccionTrasera,
          'canteado': this.cantosRinconTrasera
        };
        rincon.traseras.push(pieza);
      }

      this.mueblesDespiece.push(rincon);
    },
    calcularDespieceFregadero() {
      let hidrofugo = this.isHidrofugo ? '(HID) ' : '';
      let pieza = {};

      let fregadero = {
        'mueble': this.descripcionMueble('FREGADERO', this.anchoMueble, this.altoMueble, this.fondoMueble, this.grosorMueble, hidrofugo),
        'grosorMueble': this.grosorMueble,
        'hidrofugo': this.isHidrofugo,
        'piezas': [],
      };

      // Base
      pieza = {
        'nombre': 'Base',
        'cantidad': 1,
        'ancho': this.anchoMueble,
        'alto': this.fondoMueble - this.REDUCCION_BASE,
        'canteado': this.cantosFregaderoBase
      };
      fregadero.piezas.push(pieza);

      // Costados
      pieza = {
        'nombre': 'Costado',
        'cantidad': 2,
        'ancho': this.altoMueble - this.grosorMueble,
        'alto': this.fondoMueble,
        'canteado': this.cantosFregaderoCostados
      };
      fregadero.piezas.push(pieza);

      // Barras
      pieza = {
        'nombre': 'Barra',
        'cantidad': 2,
        'ancho': this.anchoMueble - (2 * this.grosorMueble),
        'alto': this.FREGADERO.BARRA_ALTURA,
        'canteado': this.cantosFregaderoBarras
      };
      fregadero.piezas.push(pieza);

      // Tope
      pieza = {
        'nombre': 'Tope',
        'cantidad': 1,
        'ancho': this.anchoMueble - (2 * this.grosorMueble),
        'alto': this.FREGADERO.TOPE_ALTURA,
        'canteado': this.cantosFregaderoTope
      };
      fregadero.piezas.push(pieza);

      this.mueblesDespiece.push(fregadero);
    },
    calcularDespiecePlaca() {
      let hidrofugo = this.isHidrofugo ? '(HID) ' : '';
      let pieza = {};

      let placa = {
        'mueble': this.descripcionMueble('PLACA', this.anchoMueble, this.altoMueble, this.fondoMueble, this.grosorMueble, hidrofugo),
        'grosorMueble': this.grosorMueble,
        'hidrofugo': this.isHidrofugo,
        'piezas': [],
      };

      // Base
      pieza = {
        'nombre': 'Base',
        'cantidad': 1,
        'ancho': this.anchoMueble,
        'alto': this.fondoMueble - this.REDUCCION_BASE,
        'canteado': this.cantosPlacaBase
      };
      placa.piezas.push(pieza);

      // Costados
      pieza = {
        'nombre': 'Costado',
        'cantidad': 2,
        'ancho': this.altoMueble - this.grosorMueble,
        'alto': this.fondoMueble,
        'canteado': this.cantosPlacaCostados
      };
      placa.piezas.push(pieza);

      // Barras
      pieza = {
        'nombre': 'Barra',
        'cantidad': 2,
        'ancho': this.anchoMueble - (2 * this.grosorMueble),
        'alto': this.PLACA.BARRA_ALTURA,
        'canteado': this.cantosPlacaBarras
      };
      placa.piezas.push(pieza);

      this.mueblesDespiece.push(placa);
    },
    calcularDespieceCajonera() {
      let hidrofugo = this.isHidrofugo ? '(HID) ' : '';
      let pieza = {};

      let cajonera = {
        'mueble': this.descripcionMueble('CAJONERA', this.anchoMueble, this.altoMueble, this.fondoMueble, this.grosorMueble, hidrofugo),
        'grosorMueble': this.grosorMueble,
        'hidrofugo': this.isHidrofugo,
        'piezas': [],
      };

      // Base
      pieza = {
        'nombre': 'Base',
        'cantidad': 1,
        'ancho': this.anchoMueble,
        'alto': this.fondoMueble,
        'canteado': this.cantosCajoneraBase
      };
      cajonera.piezas.push(pieza);

      // Costados
      pieza = {
        'nombre': 'Costado',
        'cantidad': 2,
        'ancho': this.altoMueble - this.grosorMueble,
        'alto': this.fondoMueble,
        'canteado': this.cantosCajoneraCostados
      };
      cajonera.piezas.push(pieza);

      // Barras
      pieza = {
        'nombre': 'Barra',
        'cantidad': 2,
        'ancho': this.anchoMueble - (2 * this.grosorMueble),
        'alto': this.CAJONERA.BARRA_ALTURA,
        'canteado': this.cantosCajoneraBarras
      };
      cajonera.piezas.push(pieza);

      this.mueblesDespiece.push(cajonera);
    },
    calcularDespieceEscurreplatos() {
      let hidrofugo = this.isHidrofugo ? '(HID) ' : '';
      let pieza = {};

      let escurreplatos = {
        'mueble': this.descripcionMueble('ESCURREPLATOS', this.anchoMueble, this.altoMueble, this.fondoMueble, this.grosorMueble, hidrofugo),
        'grosorMueble': this.grosorMueble,
        'grosorTrasera': this.grosorMueble,
        'hidrofugo': this.isHidrofugo,
        'piezas': [],
        'traseras': [],
      };

      // Costados
      pieza = {
        'nombre': 'Costados',
        'cantidad': 2,
        'ancho': this.altoMueble,
        'alto': this.fondoMueble,
        'canteado': this.cantosEscurreplatosCostados
      };
      escurreplatos.piezas.push(pieza);

      // Techo
      pieza = {
        'nombre': 'Techo',
        'cantidad': 1,
        'ancho': this.anchoMueble - (2 * this.grosorMueble),
        'alto': this.fondoMueble,
        'canteado': this.cantosEscurreplatosTecho
      };
      escurreplatos.piezas.push(pieza);

      // Baldas
      if (this.numBaldas > 0) {
        pieza = {
          'nombre': 'Balda',
          'cantidad': parseInt(this.numBaldas),
          'ancho': this.redondearUnDecimal(this.anchoMueble - (2 * this.grosorMueble) - this.HOLGURA_BALDA),
          'alto': this.fondoMueble - this.grosorMueble - this.REDUCCION_BALDA,
          'canteado': this.cantosEscurreplatosBaldas
        };
        escurreplatos.piezas.push(pieza);
      }

      // Trasera
      pieza = {
        'nombre': 'Trasera',
        'cantidad': 1,
        'ancho': this.anchoMueble - (2 * this.grosorMueble),
        'alto': this.altoMueble - this.grosorMueble,
        'canteado': this.cantosEscurreplatosTrasera
      };
      escurreplatos.traseras.push(pieza);

      this.mueblesDespiece.push(escurreplatos);
    },
    calcularDespiecePiezaLibre() {
      let hidrofugo = this.isHidrofugo ? '(HID) ' : '';
      let nombrePiezaLibre = this.nombrePiezaLibre == '' ? 'Pieza' : this.nombrePiezaLibre;
      let canteado = this.cantosPiezaLibre == '' ? 'Sin cantear' : this.cantosPiezaLibre;
      let pieza = {};

      // OJO: Si se cambia el formato del texto del mueble para Pieza Libre, hay que actualizarlo tambien para que sea igual en guardarEdicionMueble(), para cuando se editan las medidas
      let piezaLibre = {
        'mueble': parseInt(this.numPiezaLibre) + ' - ' + hidrofugo + nombrePiezaLibre + ' DE ' + this.altoMueble + ' x ' + this.anchoMueble + ' EN ' + this.grosorMueble * 10 + 'mm - ' + canteado,
        'grosorMueble': this.grosorMueble,
        'hidrofugo': this.isHidrofugo,
        'piezas': [],
      };

      // Pieza Libre
      pieza = {
        'nombre': nombrePiezaLibre,
        'cantidad': parseInt(this.numPiezaLibre),
        'ancho': this.anchoMueble,
        'alto': this.altoMueble,
        'canteado': canteado
      };
      piezaLibre.piezas.push(pieza);

      this.mueblesDespiece.push(piezaLibre);
    },
    mostrarDespieceTaller(){
      let mueble, pieza;
      this.contadorPiezasTaller = 0;
      this.despieceTaller = '';

      for(let i=0; i<this.mueblesDespiece.length; i++){
        mueble = this.mueblesDespiece[i];
        // Nombre mueble
        this.despieceTaller += mueble.mueble + '\n';

        // Para los muebles, quitando las piezas libres (Pieza Libre es el unico "mueble" con una sola pieza)
        if(mueble.piezas.length > 1){
          // Grosor mueble
          this.despieceTaller += 'Grosor: ' + mueble.grosorMueble * 10 + 'mm\n';
          // Piezas
          for(let j=0; j<mueble.piezas.length; j++){
            pieza = mueble.piezas[j];
            this.despieceTaller += pieza.cantidad + ' - ' + pieza.nombre + ' ' + pieza.ancho + ' x ' + pieza.alto + ' - ' + pieza.canteado + '\n';
            this.contadorPiezasTaller += pieza.cantidad;
          }
          // Trasera
          if(mueble.traseras){
            if (mueble.grosorMueble !== mueble.grosorTrasera) {
              this.despieceTaller += 'Grosor: ' + mueble.grosorTrasera * 10 + 'mm\n';
            }
            for(let j=0; j<mueble.traseras.length; j++){
              let trasera = mueble.traseras[j];
              this.despieceTaller += trasera.cantidad + ' - ' + trasera.nombre + ' ' + trasera.alto + ' x ' + trasera.ancho + ' - ' + trasera.canteado + '\n';
              this.contadorPiezasTaller += trasera.cantidad;
            }
          }
        }else{
          // Para contar las piezas libres
          this.contadorPiezasTaller += mueble.piezas[0].cantidad;
        }

        this.despieceTaller += '\n';
      }
    },
    generarDespiecePedido(){
      let condicionHidrofugo;
      let grosorMueble;
      let mueble;
      let pieza;
      let piezasAnadidas = [];
      let traserasAnadidas = [];
      let indiceHidrofugo;
      let indiceGrosor;
      let piezaDespiece = {};
      let cantidadPieza;
      let textoPieza, textoPiezaBusqueda;
      let muebleBusqueda, piezaBusqueda;

      // Clonar el objeto de la estructura para inicializar
      this.piezasDespiecePedido = JSON.parse(JSON.stringify(this.piezasDespiecePedidoEstructura));

      this.contadorPiezasPedido = 0;

      // Bucle para recorrer primero los muebles hidrofugos y despues los no hidrofugos
      for(let g=0; g<2; g++){
        condicionHidrofugo = (g==0) ? true : false;
        // Bucle para recorrer los grosores
        for(let h=0; h<this.GROSORES_MUEBLE.length; h++){
          grosorMueble = this.GROSORES_MUEBLE[h];
          piezasAnadidas = [];
          //// Piezas (Todas menos trasera)
          // Recorro los muebles
          for(let i=0; i<this.mueblesDespiece.length; i++){
            mueble = this.mueblesDespiece[i];
            // Si el mueble es hidrofugo o no
            if(condicionHidrofugo == mueble.hidrofugo){
              // Si el mueble es del mismo grosor
              if(grosorMueble == mueble.grosorMueble){
                // Recorro las piezas
                for(let j=0; j<mueble.piezas.length; j++){
                  cantidadPieza = 0;
                  pieza = mueble.piezas[j];
                  // Si el mueble es Pieza libre, doy la vuelta a las medidas
                  if(mueble.piezas.length == 1){
                    textoPieza = pieza.alto + ' x ' + pieza.ancho + ' - ' + pieza.canteado;
                  }else{
                    textoPieza = pieza.ancho + ' x ' + pieza.alto + ' - ' + pieza.canteado;
                  }
                  // Si la pieza ya ha sido añadida al despiece, paso a la siguiente
                  if (piezasAnadidas.indexOf(textoPieza) !== -1){
                    continue;
                  }

                  // Busco la pieza para agrupar las que sean iguales
                  // Recorro los muebles
                  for(let k=i; k<this.mueblesDespiece.length; k++){
                    muebleBusqueda = this.mueblesDespiece[k];
                    // Si el mueble es hidrofugo o no
                    if(condicionHidrofugo == muebleBusqueda.hidrofugo){
                      // Si el mueble es del mismo grosor
                      if(grosorMueble == muebleBusqueda.grosorMueble){
                        // Recorro las piezas
                        for(let l=0; l<muebleBusqueda.piezas.length; l++){
                          piezaBusqueda = muebleBusqueda.piezas[l];
                          // Si el mueble es Pieza libre, doy la vuelta a las medidas
                          if(muebleBusqueda.piezas.length == 1){
                            textoPiezaBusqueda = piezaBusqueda.alto + ' x ' + piezaBusqueda.ancho + ' - ' + piezaBusqueda.canteado;
                          }else{
                            textoPiezaBusqueda = piezaBusqueda.ancho + ' x ' + piezaBusqueda.alto + ' - ' + piezaBusqueda.canteado;
                          }

                          // Si las piezas son iguales, sumo la cantidad
                          if(textoPieza == textoPiezaBusqueda){
                            cantidadPieza += piezaBusqueda.cantidad;
                          }
                        }
                      }
                    }
                  }
                  // Añado la pieza al despiece del pedido
                  indiceHidrofugo = (mueble.hidrofugo) ? 'hidrofugo' : 'noHidrofugo';
                  switch(mueble.grosorMueble * 10){
                    case 10:
                      indiceGrosor = 'grosor10';
                      break;
                    case 16:
                      indiceGrosor = 'grosor16';
                      break;
                    case 19:
                      indiceGrosor = 'grosor19';
                      break;
                  }

                  piezaDespiece = {
                    'cantidad': cantidadPieza,
                    'pieza': textoPieza
                  }
                  this.piezasDespiecePedido[indiceHidrofugo][indiceGrosor].piezas.push(piezaDespiece);
                  this.contadorPiezasPedido += cantidadPieza;

                  // Añado la pieza al array de añadidas
                  piezasAnadidas.push(textoPieza);
                }
              }
            }
          }
        }

        //// Traseras
        traserasAnadidas = [];
        // Recorro los muebles
        for(let i=0; i<this.mueblesDespiece.length; i++){
          mueble = this.mueblesDespiece[i];
          // Si el mueble tiene traseras
          if(mueble.traseras){
            // Si el mueble es hidrofugo o no
            if(condicionHidrofugo == mueble.hidrofugo){
              // Recorro las traseras
              for(let j=0; j<mueble.traseras.length; j++){
                cantidadPieza = 0;
                pieza = mueble.traseras[j];
                textoPieza = pieza.alto + ' x ' + pieza.ancho + ' - ' + pieza.canteado;
                // Si la trasera ya ha sido añadida al despiece, paso a la siguiente
                if (traserasAnadidas.indexOf(textoPieza) !== -1){
                  continue;
                }

                // Busco la pieza para agrupar las que sean iguales
                // Recorro los muebles
                for(let k=i; k<this.mueblesDespiece.length; k++){
                  muebleBusqueda = this.mueblesDespiece[k];
                  // Si el mueble tiene traseras
                  if(muebleBusqueda.traseras){
                    // Si el mueble es hidrofugo o no
                    if(condicionHidrofugo == muebleBusqueda.hidrofugo){
                      // Recorro las traseras
                      for(let l=0; l<muebleBusqueda.traseras.length; l++){
                        // Trasera busqueda
                        piezaBusqueda = muebleBusqueda.traseras[l];
                        textoPiezaBusqueda = piezaBusqueda.alto + ' x ' + piezaBusqueda.ancho + ' - ' + piezaBusqueda.canteado;
                        // Si las piezas son iguales, sumo la cantidad
                        if(textoPieza == textoPiezaBusqueda){
                          cantidadPieza += piezaBusqueda.cantidad;
                        }
                      }
                    }
                  }
                }
                // Añado la trasera al despiece del pedido
                indiceHidrofugo = (mueble.hidrofugo) ? 'hidrofugo' : 'noHidrofugo';
                switch(mueble.grosorTrasera * 10){
                  case 10:
                    indiceGrosor = 'grosor10';
                    break;
                  case 16:
                    indiceGrosor = 'grosor16';
                    break;
                  case 19:
                    indiceGrosor = 'grosor19';
                    break;
                }

                piezaDespiece = {
                  'cantidad': cantidadPieza,
                  'pieza': textoPieza
                }
                this.piezasDespiecePedido[indiceHidrofugo][indiceGrosor].piezas.push(piezaDespiece);
                this.contadorPiezasPedido += cantidadPieza;

                // Añado la trasera al array de añadidas
                traserasAnadidas.push(textoPieza);
              }
            }
          }
        }
      }
    },
    mostrarDespiecePedido(){
      this.despiecePedido = '';
      // Genero la estructura para el despiece del pedido
      this.generarDespiecePedido();

      // Muestro el despiece del pedido

      // No Hidrofugo
      if(this.piezasDespiecePedido.noHidrofugo.grosor19.piezas.length
          || this.piezasDespiecePedido.noHidrofugo.grosor16.piezas.length
          || this.piezasDespiecePedido.noHidrofugo.grosor10.piezas.length){
        // Grosor 19mm
        let piezas19 = this.piezasDespiecePedido.noHidrofugo.grosor19.piezas;
        if(piezas19.length){
          this.despiecePedido += '\nGrosor: ' + this.piezasDespiecePedido.noHidrofugo.grosor19.grosor + 'mm\n';
          for(let i=0 ; i<piezas19.length ; i++){
            this.despiecePedido += piezas19[i].cantidad + ' - ' + piezas19[i].pieza + '\n';
          }
        }
        // Grosor 16mm
        let piezas16 = this.piezasDespiecePedido.noHidrofugo.grosor16.piezas;
        if(piezas16.length){
          this.despiecePedido += '\nGrosor: ' + this.piezasDespiecePedido.noHidrofugo.grosor16.grosor + 'mm\n';
          for(let i=0 ; i<piezas16.length ; i++){
            this.despiecePedido += piezas16[i].cantidad + ' - ' + piezas16[i].pieza + '\n';
          }
        }
        // Grosor 10mm
        let piezas10 = this.piezasDespiecePedido.noHidrofugo.grosor10.piezas;
        if(piezas10.length){
          this.despiecePedido += '\nGrosor: ' + this.piezasDespiecePedido.noHidrofugo.grosor10.grosor + 'mm\n';
          for(let i=0 ; i<piezas10.length ; i++){
            this.despiecePedido += piezas10[i].cantidad + ' - ' + piezas10[i].pieza + '\n';
          }
        }
      }

      // Hidrofugo
      if(this.piezasDespiecePedido.hidrofugo.grosor19.piezas.length
          || this.piezasDespiecePedido.hidrofugo.grosor16.piezas.length
          || this.piezasDespiecePedido.hidrofugo.grosor10.piezas.length){

        this.despiecePedido += '\nHIDRÓFUGO';
        // Grosor 19mm
        let piezas19 = this.piezasDespiecePedido.hidrofugo.grosor19.piezas;
        if(piezas19.length){
          this.despiecePedido += '\nGrosor: ' + this.piezasDespiecePedido.hidrofugo.grosor19.grosor + 'mm\n';
          for(let i=0 ; i<piezas19.length ; i++){
            this.despiecePedido += piezas19[i].cantidad + ' - ' + piezas19[i].pieza + '\n';
          }
        }
        // Grosor 16mm
        let piezas16 = this.piezasDespiecePedido.hidrofugo.grosor16.piezas;
        if(piezas16.length){
          this.despiecePedido += '\nGrosor: ' + this.piezasDespiecePedido.hidrofugo.grosor16.grosor + 'mm\n';
          for(let i=0 ; i<piezas16.length ; i++){
            this.despiecePedido += piezas16[i].cantidad + ' - ' + piezas16[i].pieza + '\n';
          }
        }
        // Grosor 10mm
        let piezas10 = this.piezasDespiecePedido.hidrofugo.grosor10.piezas;
        if(piezas10.length){
          this.despiecePedido += '\nGrosor: ' + this.piezasDespiecePedido.hidrofugo.grosor10.grosor + 'mm\n';
          for(let i=0 ; i<piezas10.length ; i++){
            this.despiecePedido += piezas10[i].cantidad + ' - ' + piezas10[i].pieza + '\n';
          }
        }
      }
    },
    editarMueble(indice){
      let mueble = this.mueblesDespiece[indice];

      this.muebleAEditar = JSON.parse(JSON.stringify(mueble));
      this.muebleAEditar.indice = indice;
    },
    guardarEdicionMueble(){
      // Para las piezas libres, actualizamos el texto del mueble, que es lo que se muestra en el despiece de taller
      if(this.muebleAEditar.piezas.length === 1) {
        let pieza = this.muebleAEditar.piezas[0];
        let hidrofugo = this.muebleAEditar.hidrofugo ? '(HID) ' : '';
        this.muebleAEditar.mueble = pieza.cantidad + ' - ' + hidrofugo + pieza.nombre + ' DE ' + pieza.alto + ' x ' + pieza.ancho + ' EN ' + this.muebleAEditar.grosorMueble * 10 + 'mm - ' + pieza.canteado;
      }

      this.mueblesDespiece[this.muebleAEditar.indice] = this.muebleAEditar;
      this.mostrarDespieceTaller();
      this.mostrarDespiecePedido();

      $('#editarMuebleModal').modal('hide');
      this.mostrarTooltipMuebleActualizado();
    },
    mostrarTooltipMuebleActualizado(){
      $('#tooltipMuebleActualizado').tooltip('enable');
      $('#tooltipMuebleActualizado').tooltip('show');
      $('#tooltipMuebleActualizado').tooltip('disable');
      $('#tooltipMuebleActualizado').on('shown.bs.tooltip', function () {
        setTimeout(function () {
          $('#tooltipMuebleActualizado').tooltip('hide');
        }, 3000);
      })
    },
    eliminarMueble(indice){
      this.mueblesDespiece.splice(indice, 1);
      this.mostrarDespieceTaller();
      this.mostrarDespiecePedido();
    },
    copiarDespiece(id){
      // Seleccionar texto y añadirlo al portapapeles
      var codigoACopiar = document.getElementById(id);
      var seleccion = document.createRange();
      seleccion.selectNodeContents(codigoACopiar);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(seleccion);
      var res = document.execCommand('copy');
      window.getSelection().removeRange(seleccion);

      // Mostrar tooltip
      if(id == 'txtDespieceTaller'){
        $('#btnCopiarDespieceTaller').tooltip('enable');
        $('#btnCopiarDespieceTaller').tooltip('show');
        $('#btnCopiarDespieceTaller').tooltip('disable');
      }else{
        $('#btnCopiarDespiecePedido').tooltip('enable');
        $('#btnCopiarDespiecePedido').tooltip('show');
        $('#btnCopiarDespiecePedido').tooltip('disable');
      }
    },
    redondearUnDecimal(numero){
      return Math.round(numero * 10) / 10;
    },
    descripcionMueble(mueble, ancho, alto, fondo, grosor, hidrofugo, gola = ""){
      return hidrofugo + gola + mueble + ' DE ' + alto + '(al) x ' + ancho + '(an) x ' + fondo + '(fon) EN ' + grosor * 10 + 'mm';
    },
    seleccionarOpcionesTodoCanteado(){
      this.cantosCascoAltoBase = this.isGola ? DATA.CASCO_ALTO.CANTOS.BASE.op1 : DATA.CASCO_ALTO.CANTOS.BASE.op2;
      this.cantosCascoAltoCostados = DATA.CASCO_ALTO.CANTOS.COSTADO.op3;
      this.cantosCascoAltoTecho = DATA.CASCO_ALTO.CANTOS.TECHO.op2;
      this.cantosCascoAltoBaldas = DATA.CASCO_ALTO.CANTOS.BALDA.op3;
      this.cantosCascoAltoDivisores = DATA.CASCO_ALTO.CANTOS.DIVISOR.op1;
      this.cantosCascoAltoTrasera = this.isCanal ? DATA.CASCO_ALTO.CANTOS.TRASERA.op1 : DATA.CASCO_ALTO.CANTOS.TRASERA.op9;

      this.cantosCascoBajoBase = DATA.CASCO_BAJO.CANTOS.BASE.op4;
      this.cantosCascoBajoCostados = DATA.CASCO_BAJO.CANTOS.COSTADO.op3;
      this.cantosCascoBajoTecho = DATA.CASCO_BAJO.CANTOS.TECHO.op2;
      this.cantosCascoBajoBaldas = DATA.CASCO_BAJO.CANTOS.BALDA.op3;
      this.cantosCascoBajoDivisores = DATA.CASCO_BAJO.CANTOS.DIVISOR.op1;
      this.cantosCascoBajoTrasera = this.isCanal ? DATA.CASCO_BAJO.CANTOS.TRASERA.op1 : DATA.CASCO_BAJO.CANTOS.TRASERA.op9;

      this.cantosRinconBaseMayor = DATA.RINCON.CANTOS.BASE_MAYOR.op2;
      this.cantosRinconBaseMenor = DATA.RINCON.CANTOS.BASE_MENOR.op2;
      this.cantosRinconCostados = DATA.RINCON.CANTOS.COSTADO.op1;
      this.cantosRinconTechoMayor = DATA.RINCON.CANTOS.TECHO_MAYOR.op3;
      this.cantosRinconTechoMenor = DATA.RINCON.CANTOS.TECHO_MENOR.op3;
      this.cantosRinconBaldaMayor = DATA.RINCON.CANTOS.BALDA_MAYOR.op3;
      this.cantosRinconBaldaMenor = DATA.RINCON.CANTOS.BALDA_MENOR.op3;
      this.cantosRinconRegleta = DATA.RINCON.CANTOS.REGLETA.op1;
      this.cantosRinconTrasera = this.isCanal ? DATA.RINCON.CANTOS.TRASERA.op1 : DATA.RINCON.CANTOS.TRASERA.op9;

      this.cantosFregaderoBase = DATA.FREGADERO.CANTOS.BASE.op4;
      this.cantosFregaderoCostados = DATA.FREGADERO.CANTOS.COSTADO.op3;
      this.cantosFregaderoBarras = DATA.FREGADERO.CANTOS.BARRA.op1;
      this.cantosFregaderoTope = DATA.FREGADERO.CANTOS.TOPE.op1;

      this.cantosPlacaBase = DATA.PLACA.CANTOS.BASE.op4;
      this.cantosPlacaCostados = DATA.PLACA.CANTOS.COSTADO.op3;
      this.cantosPlacaBarras = DATA.PLACA.CANTOS.BARRA.op1;

      this.cantosCajoneraBase = DATA.CAJONERA.CANTOS.BASE.op4;
      this.cantosCajoneraCostados = DATA.CAJONERA.CANTOS.COSTADO.op3;
      this.cantosCajoneraBarras = DATA.CAJONERA.CANTOS.BARRA.op1;

      this.cantosEscurreplatosCostados = DATA.ESCURREPLATOS.CANTOS.COSTADO.op3;
      this.cantosEscurreplatosTecho = DATA.ESCURREPLATOS.CANTOS.TECHO.op2;
      this.cantosEscurreplatosBaldas = DATA.ESCURREPLATOS.CANTOS.BALDA.op3;
      this.cantosEscurreplatosTrasera = DATA.ESCURREPLATOS.CANTOS.TRASERA.op1;

      this.cantosPiezaLibre = DATA.PIEZA_LIBRE.CANTOS.op9;
    },
    seleccionarOpcionesCanteadoPersonalizado(){
      this.cantosCascoAltoBase = DATA.CASCO_ALTO.CANTOS.BASE.op1,
      this.cantosCascoAltoCostados = DATA.CASCO_ALTO.CANTOS.COSTADO.op1,
      this.cantosCascoAltoTecho = DATA.CASCO_ALTO.CANTOS.TECHO.op1,
      this.cantosCascoAltoBaldas = DATA.CASCO_ALTO.CANTOS.BALDA.op1,
      this.cantosCascoAltoDivisores = DATA.CASCO_ALTO.CANTOS.DIVISOR.op1,
      this.cantosCascoAltoTrasera = DATA.CASCO_ALTO.CANTOS.TRASERA.op1,

      this.cantosCascoBajoBase = DATA.CASCO_BAJO.CANTOS.BASE.op1;
      this.cantosCascoBajoCostados = DATA.CASCO_BAJO.CANTOS.COSTADO.op1;
      this.cantosCascoBajoTecho = DATA.CASCO_BAJO.CANTOS.TECHO.op1;
      this.cantosCascoBajoBaldas = DATA.CASCO_BAJO.CANTOS.BALDA.op1;
      this.cantosCascoBajoDivisores = DATA.CASCO_BAJO.CANTOS.DIVISOR.op1;
      this.cantosCascoBajoTrasera = DATA.CASCO_BAJO.CANTOS.TRASERA.op1;

      this.cantosRinconBaseMayor = DATA.RINCON.CANTOS.BASE_MAYOR.op1;
      this.cantosRinconBaseMenor = DATA.RINCON.CANTOS.BASE_MENOR.op1;
      this.cantosRinconCostados = DATA.RINCON.CANTOS.COSTADO.op1;
      this.cantosRinconTechoMayor = DATA.RINCON.CANTOS.TECHO_MAYOR.op1;
      this.cantosRinconTechoMenor = DATA.RINCON.CANTOS.TECHO_MENOR.op1;
      this.cantosRinconBaldaMayor = DATA.RINCON.CANTOS.BALDA_MAYOR.op1;
      this.cantosRinconBaldaMenor = DATA.RINCON.CANTOS.BALDA_MENOR.op1;
      this.cantosRinconRegleta = DATA.RINCON.CANTOS.REGLETA.op1;
      this.cantosRinconTrasera = DATA.RINCON.CANTOS.TRASERA.op1;

      this.cantosFregaderoBase = DATA.FREGADERO.CANTOS.BASE.op1;
      this.cantosFregaderoCostados = DATA.FREGADERO.CANTOS.COSTADO.op1;
      this.cantosFregaderoBarras = DATA.FREGADERO.CANTOS.BARRA.op1;
      this.cantosFregaderoTope = DATA.FREGADERO.CANTOS.TOPE.op1;

      this.cantosPlacaBase = DATA.PLACA.CANTOS.BASE.op1;
      this.cantosPlacaCostados = DATA.PLACA.CANTOS.COSTADO.op1;
      this.cantosPlacaBarras = DATA.PLACA.CANTOS.BARRA.op1;

      this.cantosCajoneraBase = DATA.CAJONERA.CANTOS.BASE.op1;
      this.cantosCajoneraCostados = DATA.CAJONERA.CANTOS.COSTADO.op1;
      this.cantosCajoneraBarras = DATA.CAJONERA.CANTOS.BARRA.op1;

      this.cantosEscurreplatosCostados = DATA.ESCURREPLATOS.CANTOS.COSTADO.op1;
      this.cantosEscurreplatosTecho = DATA.ESCURREPLATOS.CANTOS.TECHO.op1;
      this.cantosEscurreplatosBaldas = DATA.ESCURREPLATOS.CANTOS.BALDA.op1;
      this.cantosEscurreplatosTrasera = DATA.ESCURREPLATOS.CANTOS.TRASERA.op1;

      this.cantosPiezaLibre = DATA.PIEZA_LIBRE.CANTOS.op1;
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin-top: 10px;
  text-align: center;
  color: #2c3e50;
}

#logo {
  width: 100px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.txtNombreMuebleAnadido {
  font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue